export default {
  setServiceListByCate(state, serviceList) {
    if (typeof serviceList === 'object') {
      for (let prop in serviceList) {
        state.serviceListByCate.push({
          prop: serviceList[prop]
        })
      }
    } else {
      state.serviceListByCate.push(...serviceList)
    }
  },
  resetServiceListByCate(state) {
    state.serviceListByCate = []
  },
  setCategoryList(state, list) {
    state.categoryList.push(...list)
  }
}
